import { dhFoods } from "./api"

const endpoint = "/setting"

export const getSettings = async () => {
  const response = await dhFoods.get(`${endpoint}`)

  return response.data
}

export const editSettings = async data => {
  const response = await dhFoods.patch(`${endpoint}`, data)

  return response.data
}


export const changeSettingSmsPrice = async (data) => {
  const response = await dhFoods.patch(`${endpoint}/sms-price`, data)

  return response.data
}

export const getPlatformSettings = async () => {
  const response = await dhFoods.get(`${endpoint}/platform`)

  return response.data
}

export const editPlatformSettings = async data => {
  const response = await dhFoods.patch(`${endpoint}/platform`, data)

  return response.data
}
